export function nextAutomaticSlideDeadline(
  currentDeadline: number,
  now: number,
  intervalMs: number,
  lastAuthoritativeSlideAt = 0,
): number {
  const interval = Math.max(1, intervalMs);
  const authoritativeDeadline =
    lastAuthoritativeSlideAt > 0 ? lastAuthoritativeSlideAt + interval : 0;
  if (currentDeadline <= 0) return Math.max(now + interval, authoritativeDeadline);
  return Math.max(currentDeadline, authoritativeDeadline);
}
